var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am-notification",class:( _obj = {}, _obj['am-notification--' + _vm.type] = _vm.validTypes.includes(_vm.type), _obj )},[_c('amui-icon',{staticClass:"am-notification__icon",attrs:{"name":_vm.iconName,"size":"md"}}),_c('div',{staticClass:"am-notification__message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }